/**
 * TanStack Query key factory shared by every merchant-ops hook module.
 *
 * Centralising the keys here lets every mutation invalidate the whole
 * `merchant-ops` namespace via `merchantOpsKeys.all` without leaking the
 * individual hook signatures across files.
 */
export const merchantOpsKeys = {
  all: ['merchant-ops'] as const,
  merchants: () => [...merchantOpsKeys.all, 'merchants'] as const,
  dashboard: (merchantId: string, date: string | null) =>
    [...merchantOpsKeys.all, 'dashboard', merchantId, date] as const,
  recentOrders: (merchantId: string, limit: number) =>
    [...merchantOpsKeys.all, 'recent-orders', merchantId, limit] as const,
  products: (merchantId: string, includeInactive: boolean) =>
    [...merchantOpsKeys.all, 'products', merchantId, includeInactive] as const,
  categories: (merchantId: string, includeInactive: boolean) =>
    [...merchantOpsKeys.all, 'categories', merchantId, includeInactive] as const,
  couriers: (merchantId: string) =>
    [...merchantOpsKeys.all, 'couriers', merchantId] as const,
  reviews: (merchantId: string, page: number, size: number) =>
    [...merchantOpsKeys.all, 'reviews', merchantId, page, size] as const,
  reviewsSummary: (merchantId: string) =>
    [...merchantOpsKeys.all, 'reviews-summary', merchantId] as const,
  orders: (merchantId: string, page: number, size: number) =>
    [...merchantOpsKeys.all, 'orders', merchantId, page, size] as const,
};

export const unwrap = <T,>(data: T | undefined, error: unknown): T => {
  if (error) throw error as Error;
  if (data === undefined) throw new Error('Resposta vazia do servidor');
  return data;
};
